/* LL: navigation-only observers; unrelated hero and app mutations do no work here. */
(() => {
  if (window.LLHeaderCounts) return;
  window.LLHeaderCounts = true;
  // LL: menu editor can't store ?view=box, so point BYO links at the box builder.
  const rewriteBoxLinks = (scope = document) => {
    const panel = document.querySelector('[data-ll-shop-panel]');
    if (!panel) return;
    const path = `/collections/${panel.dataset.byoHandle}`;
    const links = scope.matches?.('a[href]') ? [scope] : scope.querySelectorAll('a[href]');
    links.forEach(link => {
      if (!link.getAttribute('href').includes(path)) return;
      try {
        const url = new URL(link.getAttribute('href'), location.href);
        if (url.origin !== location.origin || url.pathname !== path || url.search) return;
        url.searchParams.set('view', panel.dataset.byoView);
        link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
      } catch { /* Leave non-URL menu values untouched. */ }
    });
  };
  const selector = '#site-header, .sticky-header, #site-menu-sidebar';
  const observers = new Map(), pending = new Set();
  let frame = 0;
  const queue = scope => {
    pending.add(scope);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      pending.forEach(node => {
        if (!node.isConnected) return;
        node.querySelectorAll('[data-header-cart-count]').forEach(count => {
          const hidden = Number(count.textContent.trim()) === 0;
          if (count.hidden !== hidden) count.hidden = hidden;
        });
        rewriteBoxLinks(node);
      });
      pending.clear();
      document.dispatchEvent(new Event('ll:header:updated'));
    });
  };
  const observe = () => {
    observers.forEach((observer, node) => { if (!node.isConnected) { observer.disconnect(); observers.delete(node); } });
    document.querySelectorAll(selector).forEach(node => {
      if (observers.has(node)) return;
      const observer = new MutationObserver(() => queue(node));
      observer.observe(node, {childList:true, characterData:true, subtree:true, attributes:true, attributeFilter:['href']});
      observers.set(node, observer);
      queue(node);
    });
  };
  // Local appends sticky clones directly to body; never watch body descendants.
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && node.matches(selector)))) observe();
  }).observe(document.body, {childList:true});
  // ResizeObserver supplies sizes without synchronous layout reads at load.
  const sizes = new Map();
  let sizeFrame = 0;
  const writeSizes = () => {
    sizeFrame = 0;
    const header = document.querySelector('#site-header[data-ll-always-sticky]');
    const ticker = document.querySelector('.ll-ticker[data-ll-sticky="true"]');
    const mobile = !matchMedia('(min-width:990px)').matches;
    const height = sizes.get(header) ?? (mobile ? 57 : 65);
    const total = height + (mobile ? (sizes.get(ticker) || 0) : 0);
    for (const [name, value] of [['--ll-header-height', height], ['--ll-sticky-height', total]]) {
      const text = `${value}px`;
      if (document.documentElement.style.getPropertyValue(name) !== text) document.documentElement.style.setProperty(name, text);
    }
  };
  const resize = new ResizeObserver(entries => {
    entries.forEach(entry => sizes.set(entry.target, entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height));
    if (!sizeFrame) sizeFrame = requestAnimationFrame(writeSizes);
  });
  const observeSizes = () => {
    resize.disconnect(); sizes.clear();
    document.querySelectorAll('#site-header, .ll-ticker').forEach(node => resize.observe(node));
  };
  document.addEventListener('shopify:section:load', event => { rewriteBoxLinks(event.target); observe(); observeSizes(); });
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(() => { observe(); observeSizes(); }));
  // Deferred collection links keep the same BYO destination without a global observer.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) rewriteBoxLinks(link);
  }, {capture:true});
  rewriteBoxLinks();
  observe(); observeSizes();
})();
